module.exports = __webpack_public_path__ + "static/media/participating universities 8.17.20 v2.fc374be8.jpg";